import Header from '../../components/Header/Header';
import MyProjects from './../../components/Projects/MyProjects';
import ContactForm from './../../components/ContactForm/ContactForm';
import AboutMe from '../../components/AboutMe/AboutMe';


const Home = () => {
  return (
    <div>
    <div className='max-w-screen-xl mx-auto px-4'>
      <Header />
      <AboutMe />
      <MyProjects />
      <ContactForm />
    </div>
  </div>
  );
};

export default Home;